import { Link } from "react-router-dom";
import { Container, PageTitle, NbCard } from "@/components/nb";
import { Stagger, Item } from "@/components/motion";
import StreakStrip from "@/components/StreakStrip";
import { FlaskConical, MessageSquare, FolderOpen, ArrowRight, ClipboardList, History, BookMarked } from "lucide-react";

const items = [
  { to: "/study/diagnostic", title: "Diagnostic Test", desc: "5 quick questions. Instant level & recommendation.", icon: FlaskConical, color: "primary", tid: "study-diagnostic" },
  { to: "/study/chat", title: "Doubt-Clearing Chat", desc: "AI tutor that explains and checks your understanding.", icon: MessageSquare, color: "secondary", tid: "study-chat" },
  { to: "/study/corner", title: "Doubt Corner", desc: "Saved doubts, notes and 3D explainer videos.", icon: FolderOpen, color: "tertiary", tid: "study-corner" },
];

export default function StudyHub() {
  return (
    <Container>
      <PageTitle eyebrow="STUDY & DOUBTS" title="Learn deeper, faster." sub="Start with a diagnostic, chat any doubt, and keep it all in your corner." />
      <StreakStrip />
      <div className="flex flex-wrap gap-2 mb-6" data-testid="study-shortcuts">
        <Link to="/study/plans" data-testid="link-plans" className="px-3 py-1 rounded-full nb-border font-mono-sl text-[11px] uppercase bg-white nb-hover flex items-center gap-1"><ClipboardList className="w-3 h-3" /> My plans</Link>
        <Link to="/study/history" data-testid="link-hist" className="px-3 py-1 rounded-full nb-border font-mono-sl text-[11px] uppercase bg-white nb-hover flex items-center gap-1"><History className="w-3 h-3" /> Result history</Link>
        <Link to="/study/bookmarks" data-testid="link-bm" className="px-3 py-1 rounded-full nb-border font-mono-sl text-[11px] uppercase bg-white nb-hover flex items-center gap-1"><BookMarked className="w-3 h-3" /> Saved tests</Link>
      </div>
      <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((i) => {
          const Icon = i.icon;
          return (
            <Item key={i.to}>
              <Link to={i.to} data-testid={i.tid} className="block h-full">
                <NbCard color={i.color} className="h-full min-h-[220px] flex flex-col justify-between nb-hover-lg">
                  <div className="flex justify-between"><Icon className="w-8 h-8" /><ArrowRight className="w-6 h-6" /></div>
                  <div>
                    <h3 className="font-heading font-black text-2xl tracking-tighter">{i.title}</h3>
                    <p className="mt-2 text-neutral-800">{i.desc}</p>
                  </div>
                </NbCard>
              </Link>
            </Item>
          );
        })}
      </Stagger>
    </Container>
  );
}
